export const equipment = {
    labels: {
    },
    modal: {
        titles: {
        },
        messages: {
        },
    },
    texts: {
        equipment_empty: "Você não adicionou um CERTIFICADO no equipamento!",
    },
};
